/**
 * Frontend JavaScript for Restaurant Menu block
 */
(function() {
	'use strict';

	function initRestaurantMenuTabs() {
		const tabsContainers = document.querySelectorAll('.restaurant-menu-tabs');

		tabsContainers.forEach(tabsContainer => {
			const tabButtons = tabsContainer.querySelectorAll('.restaurant-menu-tabs__nav-button');
			const tabPanels = tabsContainer.querySelectorAll('.restaurant-menu-tabs__panel');

			tabButtons.forEach(button => {
				button.addEventListener('click', function(e) {
					e.preventDefault();

					const tabId = this.getAttribute('data-tab-id');
					if (!tabId) return;

					// Update all buttons
					tabButtons.forEach(btn => {
						const btnTabId = btn.getAttribute('data-tab-id');
						if (btnTabId === tabId) {
							btn.classList.add('restaurant-menu-tabs__nav-button--active');
							btn.setAttribute('aria-selected', 'true');
						} else {
							btn.classList.remove('restaurant-menu-tabs__nav-button--active');
							btn.setAttribute('aria-selected', 'false');
						}
					});

					// Update all panels
					tabPanels.forEach(panel => {
						const panelTabId = panel.getAttribute('data-tab-id');
						if (panelTabId === tabId) {
							panel.classList.add('restaurant-menu-tabs__panel--active');
							panel.removeAttribute('hidden');
						} else {
							panel.classList.remove('restaurant-menu-tabs__panel--active');
							panel.setAttribute('hidden', 'hidden');
						}
					});
				});
			});
		});
	}

	// Initialize on DOM ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initRestaurantMenuTabs);
	} else {
		initRestaurantMenuTabs();
	}

	// Re-initialize for dynamically loaded content (e.g., AJAX)
	if (typeof wp !== 'undefined' && wp.domReady) {
		wp.domReady(initRestaurantMenuTabs);
	}
})();

